// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1tm97","footer":"ModalError_footer__fShp9"};